module.exports = __webpack_public_path__ + "img/chips1000.27f79e50.png";